const selectProduct = (state) => state.product.product;
var product = {};

export { product as default, selectProduct };
//# sourceMappingURL=product.js.map
